 <!-- dr panel (start) -->
 <div class="drPanel">
    
        <i class="drPanel-icon icon-dr"></i>

        <div class="drPanel-info">
            <figure class="drPanel-image">
                <img src="assets/images/dr.jpg" alt=""/>
            </figure>
            <div class="drPanel-desc">
                <div class="drPanel-name">
                    {{loginService.getUserName()}}
                </div>
                <div class="drPanel-detail">
                    {{loginService.Clinic ? loginService.Clinic : ''}}
                </div>
            </div>
        </div>

        <div class="drPanel-controls">
            <a class="drPanel-controls-item drPanel-controls-icon-gear" style='cursor: pointer;' [matMenuTriggerFor]="menu">
                Settings
            </a>
            <mat-menu #menu="matMenu">
                <a mat-menu-item (click)="goDefaults()" routerLink="/defaults">Defaults</a>
                <a mat-menu-item routerLink="/Stats" *ngIf="loginService.premissions && loginService.premissions.Stats">Stats</a>
                <a mat-menu-item routerLink="/biopsystats" *ngIf="loginService.premissions && loginService.premissions.Stats">Biopsy/polypectomy stats</a>
                <a mat-menu-item (click)="redirectAdministration('questionnaires')" *ngIf="loginService.premissions && loginService.premissions['Questionnaires']">Questionnaires</a>
                <a mat-menu-item (click)="showLimits = true" *ngIf="loginService.isAdmin && loginService.premissions && loginService.premissions.Limits">Limits</a>
                
                <!-- <a mat-menu-item>Language</a>
                <a mat-menu-item>Measurements</a> -->
            </mat-menu>
            <a (click)="logout()" class="drPanel-controls-item drPanel-controls-icon-logout" style='cursor: pointer;'>
                Logout
            </a>
        </div>
    <app-loginbox *ngIf="showLogin" (closed)="showLogin=false;" [isExport]="true"></app-loginbox>
    <app-limits *ngIf="showLimits" (closed)="showLimits=false;"></app-limits>

</div>
    <!-- dr panel (end) -->
